// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.filters *[data-v-14afd89b] {\n  margin-bottom: 1rem;\n}\n\n", ""]);
// Exports
module.exports = exports;
